// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ZeroKnowledgeLabel-module__ZeroKnowledgeLabel__VCuE8 {
    color: var(--ds-modal-default-label-color);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ZeroKnowledgeLabel": `ZeroKnowledgeLabel-module__ZeroKnowledgeLabel__VCuE8`
};
export default ___CSS_LOADER_EXPORT___;
